<template>
    <b-form-group
        :invalid-feedback="error"
        :state="state"
        :label="label"
        :label-for="'tinymce-editor-' + label">
        <small v-if="description" class="form-text mb-2">{{ description }}</small>
        <editor ref="tinymceEditor"
            v-model="content"
            v-on:input="updateValue"
            :key="timestamp"
            :id="'tinymce-editor-' + _.snakeCase(label)"
            :init="editorConfig"
            :api-key="getKey()"
            ></editor>
        <file-modal-component
            v-on:change="insertAsset"
            :show="showFileModal"
            :extensions="extensions"
            :closeModal="closeFileModal"
            ></file-modal-component>
    </b-form-group>
</template>
<script>
import Vue from 'vue';
import _ from 'lodash';
import Editor from '@tinymce/tinymce-vue';
import FileModalComponent from '../helpers/FileModalComponent';

export default {
    data() {
        const self = this;
        return {
            content: this.value,
            showFileModal: false,
            currentAsset: null,
            extensions: ['jpg', 'png', 'jpeg', 'svg', 'gif', 'pdf'],
            editor: null,
            defaultEditorConfig: {
                height: 500,
                theme: 'modern',
                readonly: this.disabled,
                relative_urls: false,
                content_css : '/css/editor.css',
                menubar: 'edit insert view format table tools help',
                block_formats: 'Paragraph=p;Header 1 =h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6',
                // menu: {
                //     insert: {title: 'Insert', items: 'link assetmanager media | template table | specialchar hr | anchor'}
                // },
                plugins: `searchreplace autolink directionality visualblocks
                    visualchars fullscreen link media template codesample table
                    charmap hr pagebreak nonbreaking anchor toc insertdatetime
                    advlist lists wordcount imagetools contextmenu
                    colorpicker textpattern help code`,
                toolbar1: 'formatselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | styleselect | assetmanager | code',
                templates: [
                    { title: 'Test template 1', content: 'Test 1' },
                    { title: 'Test template 2', content: 'Test 2' }
                ],
                style_formats: [
                    {title: 'Intro Size', block: 'p', classes: 'intro'},
                    {title: 'Bootstrap Tables', items: [
                        {title: 'Table', selector: 'table', classes: 'table '},
                        {title: 'Table Bordered', selector: 'table', classes: 'table table-bordered'},
                        {title: 'Table Hover', selector: 'table', classes: 'table table-hover'} ,
                        {title: 'Table Striped', selector: 'table', classes: 'table table-striped'} ,           
                    ]},
                ],
                setup(editor) {
                    self.editor = editor;
                    editor.shortcuts.add('ctrl+s', 'save', function () {
                        self.$emit('submit');
                    });
                    editor.shortcuts.add('meta+s', 'save', function () {
                        self.$emit('submit');
                    });
                    editor.addButton('assetmanager', {
                        text: 'Assets',
                        icon: 'image',
                        onclick() {
                            self.openFileModal();
                        }
                    });
                }
            },
        }
    },

    props: ['value', 'config', 'label', 'timestamp', 'description', 'disabled', 'required', 'state', 'error'],

    components: {
        Editor,
        FileModalComponent,
    },

    computed: {
        tinymce() {
            return this.$refs['tinymceEditor'];
        },

        editorConfig() {
            const editorConfig = _.get(this.config, 'editorConfig');
            return _.merge({}, this.defaultEditorConfig, editorConfig);
        },
    },

    methods: {
        updateValue(val) {
            this.$emit('input', val || '<p></p>');
        },

        insertAsset(asset) {
            if (asset.extension == 'pdf') {
                this.editor.insertContent(
                    '<a href="{{path}}" target="_blank">{{name}}</a>'
                        .replace('{{path}}', _.assetPath(asset, true))
                        .replace('{{name}}', asset.name)
                );
            } else {
                this.editor.insertContent(
                    '<img src="{{path}}" alt="{{alt}}"></img>'
                        .replace('{{path}}', _.imgPath(asset))
                        .replace('{{alt}}', asset.name)
                );
            }
            this.showFileModal = false;
        },

        closeFileModal() {
            this.showFileModal = false;
        },

        openFileModal() {
            this.showFileModal = true;
        },

        getKey() {
            return _.get(window, 'env.TINYMCE_KEY', '');
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/TinymceEditorComponent.vue